import { FormElement, userOnboardingStage } from "app/types";

export type IMySettingForm = {
  _id: string;
  createdAt: string;
  updatedAt: string;
  email: string;
  mobileNumber: string;
  signup: [];
  isActive: boolean;
  avatar: IAvatar;
  userOnboardingProgress: userOnboardingStage;
  language: string;
  timeFormat: string;
  dateFormat: string;
  weekStart: string;
  fullName: string;
  timeZone: string;
  hasPassword: true;
  oldEmail: FormElement;
  newEmail: FormElement;
  oldPassword: FormElement;
  newPassword: FormElement;
  confirmPassword: FormElement;
};
export enum ENUM_USER_TIME_FORMAT {
  TWELVE_HOUR = "12 hour",
  TWENTY_FOUR_HOUR = "24 hour",
}
export enum ENUM_USER_WEEK_START {
  SUNDAY = "Sunday",
  MONDAY = "Monday",
  TUESDAY = "Tuesday",
  WEDNESDAY = "Wednesday",
  THURSDAY = "Thursday",
  FRIDAY = "Friday",
  SATURDAY = "Saturday",
}
export interface IFormError {
  name: string;
  error: string;
}

export interface ICountryListOption {
  value: string;
  label: string;
}
export interface IAvatar {
  fileId: string;
  icon: string;
  color: string;
  file: string;
  _id: string;
}

export interface IMySettingTypeState {
  form: IMySettingForm;
  isLoading: boolean;
  hasPassword: boolean;
  buttonLoading: boolean;
  verifyCodeError: string;
  changeEmailRequestId: string;
}
